export const onEditDialogDone = token => ({
  widget: 'tokens',
  type: 'onEditDialogDone',
  payload: { token },
})



// WEBPACK FOOTER //
// ./src/tokens/actions/onEditDialogDone.js